export default [
    // {
    //     text: 'Validar',
    //     value: '',
    //     sortable: false,
    // },
    {
        text: 'Fecha',
        value: 'bank_card_date',
    },
    {
        text: 'Detalle Movimiento',
        value: 'movement_detail',
    },
    {
        text: 'Cheque o Cargo',
        value: 'charge',
    },
    {
        text: 'Deposito o abono',
        value: 'deposit',
    },
    // {
    //     text: 'Saldo',
    //     value: 'balance',
    // },
    {
        text: 'Docto. Nro.',
        value: 'document_number',
    },
    {
        text: 'Sucursal',
        value: 'branch_office',
    },
    {
        text: 'En sistema',
        value: 'already_in_database',
    },
    
]
